import { useEffect } from 'react'
import { useAuthStore } from '@/store/authStore'

/**
 * Component to check authentication status on app mount
 * This runs once when the app loads to restore any existing session
 */
export default function AuthChecker() {
  const checkAuth = useAuthStore((state) => state.checkAuth)

  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  return null
}
